var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390.63 345.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#_65);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        opacity: .7;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#Gradiente_sem_nome_13-3);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Gradiente_sem_nome_13-2);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Gradiente_sem_nome_13);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#Gradiente_sem_nome_4);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#Gradiente_sem_nome_4-2);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Gradiente_sem_nome_13-4);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 55.11,
    y1: 310.2,
    x2: 55.11,
    y2: 287.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dad3d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b3adaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#746f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cbc9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8f8a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#655e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8dbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9ea3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 41.88,
    y1: 345.62,
    x2: 41.88,
    y2: 249.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 182.4,
    y1: 345.62,
    x2: 182.4,
    y2: 248.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 344.89,
    y1: 345.62,
    x2: 344.89,
    y2: 249.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    "data-name": "Gradiente sem nome 13",
    x1: 41.88,
    y1: 342.16,
    x2: 41.88,
    y2: 253.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f7539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#977c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b0913f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d0ad46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d5b64d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dcc258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#dfc75c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e3ce61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e6d365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e8d76e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ede181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e9db7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0cc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d2b44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ccaa45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c09f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ab8d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9f823a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9b7f3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#967b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8a7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#755f32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#67532f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5f4f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#574a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13-2",
    "data-name": "Gradiente sem nome 13",
    x1: 131.52,
    x2: 131.52,
    y2: 251.84,
    xlinkHref: "#Gradiente_sem_nome_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13-3",
    "data-name": "Gradiente sem nome 13",
    x1: 247.03,
    x2: 247.03,
    xlinkHref: "#Gradiente_sem_nome_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13-4",
    "data-name": "Gradiente sem nome 13",
    x1: 344.89,
    x2: 344.89,
    xlinkHref: "#Gradiente_sem_nome_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 241.38,
    y1: 16.99,
    x2: 152.39,
    y2: 203.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 147.38,
    y1: 47.65,
    x2: 245.8,
    y2: 181.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#51545b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_65",
    "data-name": "????? ??????? ????????? 65",
    x1: 151.5,
    y1: 53.26,
    x2: 239.24,
    y2: 172.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdad7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#d0cbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a9a5a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8b878d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e4e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bfbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#837f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807c81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    cx: 195.38,
    cy: 112.97,
    fx: 195.38,
    fy: 112.97,
    r: 68.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d7d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 177.25,
    y1: 33.89,
    x2: 222.32,
    y2: 230.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#262f63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#253789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3452a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3554a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3554a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#243f93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#283475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1d1f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080a16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_4-2",
    "data-name": "Gradiente sem nome 4",
    cy: 112.97,
    fy: 112.97,
    r: 67.38,
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 136.13,
    y1: 103.19,
    x2: 244.41,
    y2: 103.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 157.13,
    y1: 130.78,
    x2: 251.41,
    y2: 130.78,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 138.2,
    y1: 103.19,
    x2: 242.33,
    y2: 103.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 159.21,
    y1: 130.78,
    x2: 249.34,
    y2: 130.78,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 30.15,
    y: 287.11,
    width: 49.93,
    height: 23.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "83.75 249.61 0 249.61 0 345.62 25.91 345.62 25.91 275.64 83.75 275.64 83.75 249.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M266.94,285.88h-40.07c-3.53,0-5.24-1.67-5.24-5.12s1.67-5.12,5.24-5.12h67.92v-26.03h-67.92c-19.45,0-32.01,11.46-32.01,29.19s12.77,29.07,31.77,29.07h40.32c7.33,0,7.33,4.5,7.33,5.98,0,4.74-3.98,5.73-7.33,5.73h-70.74v23.98l-52.53-87.38c-3.11-5.18-7.2-7.81-12.16-7.81s-9.05,2.63-12.15,7.8l-53.76,89.43h29.78l35.41-60.03,10.21,17.2h-16l-12.76,21.74h41.69l12.5,21.08h100.5c19.9,0,32.26-11.56,32.26-30.17,0-13.49-5.6-29.56-32.26-29.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "299.15 249.61 299.15 275.64 331.87 275.64 331.87 345.62 357.91 345.62 357.91 275.64 390.63 275.64 390.63 249.61 299.15 249.61"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3.46,342.16v-89.09h76.84v19.12H22.45v69.98H3.46ZM33.6,306.74v-16.18h43.02v16.18h-43.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.41,342.16l-12.5-21.08h-37.62l8.7-14.83h20.1l-16.3-27.45-37.38,63.36h-21.69l50.61-84.19c2.21-3.68,5.02-6.13,9.19-6.13s6.99,2.45,9.19,6.13l50.61,84.19h-22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.67,342.16v-19.12h67.28c6.86,0,10.78-3.55,10.78-9.19,0-6-3.92-9.44-10.78-9.44h-40.32c-17.52,0-28.31-10.54-28.31-25.61s10.05-25.74,28.55-25.74h64.46v19.12h-64.46c-5.39,0-8.7,3.06-8.7,8.58s3.43,8.58,8.7,8.58h40.07c18.75,0,28.8,8.33,28.8,26.1,0,15.32-9.44,26.72-28.8,26.72h-67.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M335.33,342.16v-69.98h-32.72v-19.12h84.56v19.12h-32.72v69.98h-19.12Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M284.96,115.88l23.42-8.76c0-.11,0-.22-.02-.32l-2.06-16.21-.02-.13s0-.04-.03-.06l-25.02-3.15c-1.32-4.44-3-8.75-4.98-12.89l16.44-19.13v-.02l-.17-.25-9.35-13.36-.08-.1s-.07-.07-.09-.12l-23.25,9.29c-3.57-3.7-7.46-7.09-11.63-10.13l5.97-24.32s-.04-.02-.06-.04l-.12-.07-14.85-7.56-16.67,18.94c-4.59-1.47-9.35-2.58-14.23-3.26L202.08.02c-.05-.02-.07-.02-.12-.02h-.09l-15.81.21-.35.02c-.17,0-.33.02-.48.04l-5.91,24.51c-4.63.82-9.13,2.02-13.5,3.55l-17.23-18.43-14.78,8.11,6.68,24.13c-3.85,3-7.46,6.3-10.79,9.86l-23.43-8.79c-.05.07-.13.17-.19.25l-.08.1-9,13.44-.13.21v.02l16.82,18.8c-1.94,4.29-3.56,8.78-4.82,13.42l-24.95,3.77c-.03.13-.04.27-.06.41l-.02.13-1.59,15.83v.04c-.02.12-.02.23-.02.36l23.63,8.14c.29,5.1.99,10.07,2.12,14.9l-20.43,14.4v.02c0,.06.03.12.06.18l.04.12,6.03,14.93.12.25c.02.05.04.12.07.17l25.03-3.33c2.35,3.81,4.98,7.46,7.84,10.85l-11.14,22.64c.12.13.23.25.36.36l.02.02,11.85,10.13.57.48,20.2-14.8c4.01,2.47,8.22,4.63,12.63,6.45l-.04,25.02.07.03,16.07,3.81h.05c.05.02.13.02.21.04l11.75-22.36c1.98.13,4,.21,6.02.21,2.71,0,5.38-.12,8.02-.36l12.2,22.09c.06,0,.12,0,.15-.02l.18-.04,16-4.18-.59-25.03c4.41-1.92,8.62-4.19,12.63-6.78l20.52,14.3c.1-.06.17-.13.27-.21l.05-.04,11.7-10.49.04-.04c.18-.16.35-.33.5-.5l-11.67-22.4c2.86-3.56,5.45-7.36,7.74-11.34l25.12,2.65s.05-.1.07-.16l5.8-15.63-20.82-13.85c.97-4.79,1.54-9.71,1.69-14.72ZM195.37,183.55c-38.91,0-70.57-31.64-70.57-70.57s31.66-70.58,70.57-70.58,70.58,31.67,70.58,70.58-31.67,70.57-70.58,70.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M195.37,186.41c-40.49,0-73.43-32.94-73.43-73.43s32.94-73.44,73.43-73.44,73.44,32.94,73.44,73.44-32.94,73.43-73.44,73.43ZM195.37,44.22c-37.91,0-68.75,30.85-68.75,68.76s30.84,68.75,68.75,68.75,68.76-30.84,68.76-68.75-30.85-68.76-68.76-68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.37,187.1c-40.87,0-74.12-33.25-74.12-74.12s33.25-74.13,74.12-74.13,74.13,33.25,74.13,74.13-33.25,74.12-74.13,74.12ZM195.37,40.23c-40.11,0-72.74,32.63-72.74,72.75s32.63,72.74,72.74,72.74,72.75-32.63,72.75-72.74-32.63-72.75-72.75-72.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M195.37,181.73c-37.91,0-68.75-30.84-68.75-68.75s30.84-68.76,68.75-68.76,68.76,30.85,68.76,68.76-30.85,68.75-68.76,68.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M195.37,180.35c-37.15,0-67.37-30.22-67.37-67.37s30.22-67.38,67.37-67.38,67.38,30.23,67.38,67.38-30.23,67.37-67.38,67.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M195.37,180.35c-37.15,0-67.37-30.22-67.37-67.37s30.22-67.38,67.37-67.38,67.38,30.23,67.38,67.38-30.23,67.37-67.38,67.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153,151.63c-1.43,0-2.31-1.03-3.24-2.11-7.33-8.55-11.76-18.61-13.16-29.9-1.51-12.2.64-23.8,6.39-34.48,4.22-7.84,10.03-14.44,17.25-19.62,9.96-7.14,21.16-10.75,33.31-10.75,1.07,0,2.17.03,3.26.08,13.15.68,24.92,5.48,34.96,14.27,4.32,3.78,8.11,8.31,11.57,13.86.05.08.11.15.16.23.4.56,1.48,2.04.53,3.72-.5.9-1.41,1.41-2.5,1.41-.33,0-.62-.04-.85-.08-.08-.01-.16-.03-.23-.03-1.19,0-2.4,0-3.62,0h-3.9c-1.78,0-3.56,0-5.34.02h-.09c-1.88,0-3.4-.67-4.64-2.05-6.82-7.59-15.15-11.79-25.46-12.85-1.26-.13-2.54-.19-3.81-.19-14.35,0-27.88,8.17-34.46,20.82-4.96,9.54-5.93,19.56-2.89,29.82.58-.6,1.17-1.2,1.76-1.8,1.82-1.86,3.7-3.78,5.48-5.72,1.48-1.61,3.19-2.35,5.4-2.35,8.81.03,17.6.03,26.39.03h22.28c.53,0,1.07-.02,1.6-.04.49-.01.99-.03,1.48-.03.06,0,.13,0,.19,0,.15,0,.3-.02.45-.02,1.85,0,2.58,1.19,2.81,1.71.38.86.5,2.15-1.05,3.44-.04.03-.08.06-.11.1-.83.84-1.7,1.68-2.54,2.49-1.81,1.74-3.52,3.38-4.99,5.21-2.11,2.63-4.61,3.8-8.11,3.8-.29,0-.58,0-.88-.02-1.6-.08-3.32-.12-5.43-.12-1.37,0-2.73.01-4.1.03-1.37.02-2.74.03-4.11.03h-8.74c-2.54,0-5.07,0-7.61-.02h0c-.75,0-1.17.18-1.69.7-4.64,4.69-9.39,9.43-13.98,14.01l-4.49,4.48c-1.08,1.08-1.93,1.93-3.24,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.7,170.01c-6.49,0-13.15-1.2-19.8-3.58-4.92-1.75-9.7-4.38-15.06-8.27-.48-.35-1.61-1.17-1.7-2.58-.09-1.42.96-2.41,1.35-2.78,2.29-2.15,4.7-4.56,7.59-7.57.92-.96,1.93-1.45,3.01-1.45.84,0,1.67.29,2.52.9,4.93,3.52,10.54,5.69,16.66,6.47,1.97.25,3.91.38,5.79.38,6.44,0,12.47-1.51,17.92-4.48,11.84-6.46,18.81-16.54,20.74-29.97.32-2.26.23-4.59.13-7.06-.02-.62-.05-1.24-.07-1.86,0,0,0-.02,0-.02-.12-.01-.3-.02-.54-.02-9.02.02-18.02.03-27.02.03s-18,0-26.99-.02c-.15,0-.32.03-.49.05-.31.04-.66.08-1.03.08-2,0-2.72-1.27-2.93-1.82-.79-2.01.95-3.34,1.61-3.84.14-.1.34-.26.4-.33,1.18-1.25,2.38-2.49,3.57-3.73,1.52-1.57,3.09-3.2,4.6-4.83,1.35-1.46,2.98-2.14,5.12-2.14,4.58.02,9.1.03,13.62.03h13.76c2.36,0,11.79,0,14.14,0,5.29,0,9.35-.01,13.18-.04,2.69,0,4.27,1.19,5.03,3.73,1.91,6.41,2.77,12.21,2.6,17.75-.47,16.17-6.47,29.91-17.81,40.85-9.19,8.86-20.42,14.15-33.4,15.73-2.15.26-4.33.39-6.48.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.75,128.45c-5.44,0-10.89.03-16.33-.02-1.3-.01-2.27.39-3.19,1.32-6.13,6.19-12.3,12.33-18.46,18.49-1.75,1.75-1.84,1.79-3.44-.07-7.14-8.32-11.33-17.97-12.68-28.81-1.45-11.7.55-22.83,6.16-33.24,4.08-7.58,9.62-13.89,16.64-18.92,10.55-7.57,22.37-10.95,35.25-10.28,12.77.66,24.03,5.29,33.7,13.76,4.45,3.89,8.07,8.42,11.18,13.39.35.56,1.02,1.18.64,1.84-.34.61-1.16.24-1.76.24-4.3.03-8.59-.02-12.89.03-1.3.01-2.28-.38-3.16-1.36-7.17-7.98-16.1-12.43-26.79-13.53-16.36-1.68-32.69,7.05-40.32,21.73-5.58,10.73-6.34,21.83-2.43,33.27.44,1.28.84,1.06,1.57.3,2.85-2.97,5.79-5.88,8.57-8.91,1.11-1.2,2.27-1.69,3.89-1.68,16.21.05,32.43.03,48.64.02,1.03,0,2.06-.06,3.09-.07.56,0,1.26-.17,1.54.45.25.57-.39.89-.73,1.24-2.57,2.61-5.39,5.02-7.68,7.87-2,2.49-4.24,3.15-7.27,3-4.57-.23-9.16-.06-13.75-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M216.44,93.66c9.11,0,18.22.03,27.34-.03,1.72-.01,2.52.56,3.02,2.25,1.67,5.59,2.69,11.3,2.52,17.1-.45,15.4-6.01,28.65-17.18,39.42-9.02,8.7-19.81,13.65-32.21,15.16-8.69,1.06-17.12-.15-25.34-3.08-5.28-1.88-10.02-4.72-14.54-7.99-1.04-.75-1.17-1.21-.15-2.17,2.63-2.47,5.17-5.04,7.67-7.65.94-.98,1.76-1.06,2.82-.3,5.29,3.77,11.18,6.02,17.6,6.84,8.75,1.11,17.15-.08,24.97-4.34,12.53-6.84,19.78-17.4,21.8-31.49.44-3.06.17-6.18.08-9.27-.05-1.77-1.09-2.06-2.64-2.06-17.99.04-35.99.03-53.98,0-.88,0-2.2.45-2.53-.38-.31-.79.99-1.35,1.59-1.99,2.71-2.88,5.5-5.67,8.18-8.57,1.03-1.11,2.17-1.48,3.64-1.47,9.11.05,18.22.02,27.34.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.80e434192291c1415270d53aab324aad.svg";
export { ForwardRef as ReactComponent };